<!-- Image Gallery -->
@if (imageData.length > 0 && deviceType === "mobile") {
  <div
    class="relative flex flex-col-reverse justify-center items-center w-full"
  >
    <div class="flex justify-center mt-3">
      @for (image of imageData; track image.image_code; let i = $index; let last = $last) {
        <img
          [ngClass]="{
            'border-zestBlack': inview[i] === true,
            'border-zestBg':    inview[i] === false,
            'mr-0': last
          }"
          class="w-[104px] h-[88px] border rounded mb-4 cursor-pointer mr-3 p-2 object-contain"
          [src]="image.image_source"
          (click)="owlCar.to(image.image_code)"
          alt="product thumbnail"
        />
      }
    </div>

    <div
      class="w-full flex justify-center items-center mx-auto rounded backdrop-blur-sm my-auto"
    >
      <owl-carousel-o
        #owlCar
        [options]="carouselOptions"
        class="w-6/12 relative"
        (translated)="onSlideChange($event)"
      >
        @for (image of imageData; track image.image_code) {
          <ng-template carouselSlide [id]="image.image_code">
            <img
              [src]="image.image_source"
              alt="product image"
              class="rounded mx-auto object-contain max-h-[320px] w-full"
            />
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>
} @else {
  <div class="flex items-start xl:w-7/12 grow">
    <!-- Side thumbnail column -->
    <div class="w-1/5 flex flex-col justify-start mr-8 shrink-0">
      @for (image of imageData; track image.image_code; let i = $index) {
        <img
          [ngClass]="{
            'border-zestBlack': inview[i] === true,
            'border-zestBg':    inview[i] === false
          }"
          class="w-20 h-20 border rounded mb-4 cursor-pointer p-1 object-contain"
          [src]="image.image_source"
          (click)="owlCarDesktop.to(image.image_code)"
          alt="product thumbnail"
        />
      }
    </div>

    <!-- Main carousel -->
    <div class="flex-1 flex justify-center items-start h-[500px]">
      <owl-carousel-o
        #owlCarDesktop
        [options]="carouselOptions"
        class="w-[500px] h-full"
        (translated)="onSlideChange($event)"
      >
        @for (image of imageData; track image.image_code) {
          <ng-template carouselSlide [id]="image.image_code">
            <img
              [src]="image.image_source"
              alt="product image"
              class="rounded mx-auto h-full object-contain"
            />
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>
}
